module.exports = __webpack_public_path__ + "img/alex_competencies.6416703e.svg";